export const generateDocAction = async ({
  clientUid,
  computerId,
  docId,
  status,
  url,
}) => {
  const firebaseUrl = process.env.REACT_APP_SIMPLY_KIOSK_URL;

  const objectToSend = {
    action: "public_computer_session_update_document",
    userUid: clientUid,
    macAdress: computerId,
    updateData: {
      document_id: docId,
      download_status: status,
      url: url,
    },
  };

  console.log("OBJECT TO SEND", objectToSend);

  try {
    const response = await fetch(firebaseUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(objectToSend),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    console.log("result", result);

    return result;
  } catch (error) {
    console.error("Erreur lors de l'envoi de la requête POST:", error);
  }
};
